import { toLower, last } from 'ramda';

export const isComment = question => {
    const strings = (question || '').split('|');

    return strings.length > 1 && toLower(last(strings)) === 'комментарий';
}
